import { shareToKakao } from '~/utils/kakao';
import { MARKET_BASE_URL } from '~/utils/url';

type Props = {
  receiverName: string;
  name: string;
  id: string;
  description?: string;
};

/**
 * @description ECoupon 구매한 상품을 카카오톡으로 공유하기
 * */
export function shareECouponByKakao({
  receiverName,
  name,
  id,
  description,
}: Props) {
  shareToKakao({
    objectType: 'feed',
    content: {
      title: `${receiverName}님,\n${name}님이 선물을 보냈습니다.`,
      imageUrl:
        'https://marketplace-asset.kcd.co.kr/promotion/20260107061104_AUQBH35W.png',
      link: {
        webUrl: `${MARKET_BASE_URL}/external/e-coupon/${id}`,
        mobileWebUrl: `${MARKET_BASE_URL}/external/e-coupon/${id}`,
      },
      description,
      imageHeight: 80,
    },
    buttonTitle: '선물 보러가기',
    installTalk: true,
  });
}
